import { useTranslation } from 'react-i18next';

import Img_Demo_WKO from '../image/Demo_WKO.png';
import Img_Demo_LBK from '../image/Demo_LBK.png';
import Img_Demo_Gebouw from '../image/Demo_Gebouw.png';
import Img_Demo_Verdieping from '../image/Demo_Verdieping.png';
import Img_Demo_Verdieping_2 from '../image/Demo_Verdieping_2.png';
import Img_Design from '../image/simple/undraw_product_iteration.svg';
import Img_Installment from '../image/simple/undraw_setup_wizard.svg';
import Img_Development from '../image/simple/undraw_web_developer.svg';
import Img_Maintenance from '../image/simple/undraw_air_support.svg';
import Img_AFAS_Leusden from '../image/projects/AFAS_Campus_Leusden_Storkstraat.jpg';
import Img_Westfield_Hamburg from '../image/projects/Westfield_Hamburg_Überseequartier.jpg';
import Img_Wonderwoods_Utrecht from '../image/projects/Wonderwoods_Utrecht_Centrum.jpg';
import Img_VierGrafinnen_Tiel from '../image/projects/VierGrafinnen_Tiel.jpg';
import Img_Ytowers_Amsterdam from '../image/projects/ytowers_amsterdam.jpg';
import Img_NBC_Nieuwegein from '../image/projects/NBC_Nieuwegein.jpg';
import Img_Inholland_IJburg_Amsterdam from '../image/projects/Inholland_IJburg_Amsterdam.png';
import Img_DSV_Moerdijk from '../image/projects/DSV-Moerdijk-docks-ASSA-ABLOY.png';
import Img_DigitalRealty_AMS11 from '../image/projects/digitalrealty-ams-11-07-2024-video.png';
import Img_Mitsubishi_Rotterdam from '../image/projects/Mitsubishi_MXDA_Rotterdam.jpg';

export const useHomeContent = () => {
  const { t } = useTranslation();

  const projectImageMap = {
    westfield: Img_Westfield_Hamburg,
    wonderwoods: Img_Wonderwoods_Utrecht,
    viergravinnen: Img_VierGrafinnen_Tiel,
    afas: Img_AFAS_Leusden,
    ytowers: Img_Ytowers_Amsterdam,
    nbc: Img_NBC_Nieuwegein,
    inholland: Img_Inholland_IJburg_Amsterdam,
    dsv: Img_DSV_Moerdijk,
    digitalrealty: Img_DigitalRealty_AMS11,
    mitsubishi: Img_Mitsubishi_Rotterdam,
  };

  const translatedProjectItems = t('home.projects.items', { returnObjects: true });
  const projectItems = (Array.isArray(translatedProjectItems) ? translatedProjectItems : []).map((projectItem) => ({
    ...projectItem,
    image: projectImageMap[projectItem.id],
  }));

  const projectColumns = [
    projectItems.filter((_, index) => index % 3 === 1),
    projectItems.filter((_, index) => index % 3 === 0),
    projectItems.filter((_, index) => index % 3 === 2),
  ];

  const softwareImageMap = {
    wko: Img_Demo_WKO,
    lbk: Img_Demo_LBK,
    gebouw: Img_Demo_Gebouw,
    verdieping1: Img_Demo_Verdieping,
    verdieping2: Img_Demo_Verdieping_2,
  };

  const translatedSoftwareSlides = t('home.software.slides', { returnObjects: true });
  const softwareSlides = (Array.isArray(translatedSoftwareSlides) ? translatedSoftwareSlides : []).map((softwareSlide) => ({
    ...softwareSlide,
    image: softwareImageMap[softwareSlide.id],
  }));

  const serviceImageMap = {
    design: Img_Design,
    development: Img_Development,
    installment: Img_Installment,
    maintenance: Img_Maintenance,
  };

  const translatedServiceItems = t('home.service.items', { returnObjects: true });
  const serviceItems = (Array.isArray(translatedServiceItems) ? translatedServiceItems : []).map((serviceItem) => ({
    ...serviceItem,
    image: serviceImageMap[serviceItem.imageId],
  }));

  const translatedWhyCards = t('home.why.cards', { returnObjects: true });
  const whyCards = Array.isArray(translatedWhyCards) ? translatedWhyCards : [];
  const translatedCapabilities = t('home.hero.capabilities', { returnObjects: true });
  const heroCapabilities = Array.isArray(translatedCapabilities) ? translatedCapabilities : [];

  return {
    projectColumns,
    softwareSlides,
    serviceItems,
    whyCards,
    heroCapabilities,
  };
};
